import type React from "react";
import { Link } from "react-router-dom";

interface EventReportCardProps {
	report: {
		id: number;
		title: string;
		date: string;
		summary: string;
		imageUrl: string;
	};
}

const EventReportCard: React.FC<EventReportCardProps> = ({ report }) => {
	return (
		<div className="bg-white rounded-lg shadow-md overflow-hidden">
			<img
				src={report.imageUrl}
				alt={report.title}
				className="w-full h-48 object-cover"
			/>
			<div className="p-6">
				<h3 className="text-xl font-semibold mb-2">{report.title}</h3>
				<p className="text-gray-600 mb-2">{report.date}</p>
				<p className="mb-4">{report.summary}</p>
				<Link
					to={`/event-report/${report.id}`}
					className="text-blue-500 hover:underline"
				>
					詳細を読む
				</Link>
			</div>
		</div>
	);
};

export default EventReportCard;
